export const errorCodeTypes = {
  invalidDaysAheadError: {
    code: 'SCH01',
    name: 'InvalidDaysAheadError',
    message:
      'The lead time (days in advance) cannot exceed the recurrence interval to prevent overlapping tasks.',
  },
  invalidScheduledDueDateError: {
    code: 'SCH02',
    name: 'InvalidScheduledDueDateError',
    message: 'The scheduled due date is invalid.',
  },
};
